'use es6';

import PropTypes from 'prop-types';
export default PropTypes.shape({
  /* eslint-disable-next-line react/forbid-prop-types */
  filterGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  objectTypeId: PropTypes.string
});